export default __webpack_public_path__ + "static/Sailec-Regular-51997a9198161a9699105c9a79c60054.woff2";